const slugToTitleDict = {
    "databases": "Databases",
    "general": "Database Settings",
    "filters": "Filters",
    "filter": "Filters",
    "database": "Databases",
    "tos": "Terms of Service",
    "privacy": "Privacy Policy",
    "users": "Users",
    "user": "Users",
    "roles": "Roles",
    "role": "Roles",
    "organization_users" : "Organization Users",
    "organization_user": "Organization Users",
}

export const convertSlugToTitle = (slug: string, prev?: string) => {
    if (slug in slugToTitleDict) {
        return slugToTitleDict[slug]
    } else if (slug.startsWith("create")) {
        const element = slugToTitleDict[prev].slice(0, -1)
        return "Create " + element
    } else if (slug.startsWith("srv_")) {
        return "Edit Database"
    } else if (slug.startsWith("fltr_")) {
        return "Edit Filter"
    } else if (slug.startsWith("synusr_")) {
        return "Edit User"
    } else if (slug.startsWith("org_")) {
        return "Edit Organization"
    } else if (slug.startsWith("usr_")) {
        return "Edit Organization User"
    } else {
        return slug
    }
}

export default convertSlugToTitle
